import CardCollectionList from '@/components/sections/builder/elements/body/card-collection-list';
import { CollectionListPageElementDataType } from '@/components/sections/builder/elements/body/collection-list-page/type';
import { ElementProps } from '@/components/sections/builder/types';
import { SORTINGCOLLECTIONLIST } from '@/constant/dummyData/dummy-filter-sorting';
import { useCollections } from '@/hooks/api/storefront/collections';
import { cn } from '@/lib/utils';

export default function ElementContent({ element, preview }: ElementProps) {
  const data = element.data as CollectionListPageElementDataType;
  const queryParams = SORTINGCOLLECTIONLIST[data.sortingCollection as 'title-ascending'];

  const {
    data: collectionsData,
    isLoading,
    error,
  } = useCollections({
    page: 1,
    pageSize: 100,
    ...queryParams,
  });
  const collections = collectionsData?.data || [];

  return (
    <section className='background-color theme_layout_page_width mx-auto w-full px-4 py-4 lg:px-5'>
      <div className=''>
        {error ? (
          <div className='h-full w-full place-content-center'>
            <h2 className='text text-xl font-semibold'>
              Oops,Collection list something went wrong.
            </h2>
          </div>
        ) : isLoading ? (
          <div className='min-h-[calc(100vh_-_2rem)]'>
            <div className='my-5 h-4 w-1/4 animate-pulse rounded bg-gray-300'></div>
            <div
              className={cn(
                `grid grid-cols-${data.totalColMobile} md:grid-cols-${
                  data.totalColMobile
                } lg:grid-cols-${data.totalCol - 1} xl:grid-cols-${data.totalCol} gap-2 gap-y-4`
              )}
            >
              {Array.from({ length: data.totalCol }).map((_, index) => (
                <div key={index} className='w-full place-content-center'>
                  <div className='mx-auto w-full max-w-sm'>
                    <div className='space-y-2'>
                      <div className='aspect-square animate-pulse rounded-lg bg-gray-300'></div>
                      <div className='h-6 animate-pulse rounded bg-gray-300'></div>
                      <div className='h-4 w-1/4 animate-pulse rounded bg-gray-300'></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <h1
              className={cn(
                'text-color-scheme mb-4',
                data.headingSize === 'large' && 'text-xl sm:text-2xl md:text-3xl lg:text-4xl',
                data.headingSize === 'medium' && 'text-lg sm:text-xl md:text-2xl lg:text-3xl',
                data.headingSize === 'small' && 'text-base md:text-lg lg:text-xl xl:text-2xl'
              )}
              data-animation='true'
              dangerouslySetInnerHTML={{ __html: data.heading || '' }}
            />
            <div
              className={cn(
                `grid-cols-${data.totalColMobile} sm:grid-cols-${data.totalCol} md:grid-cols-${
                  data.totalCol - 1
                } lg:grid-cols-${data.totalCol - 1} xl:grid-cols-${
                  data.totalCol
                } theme_layout_space_grid_horizontal theme_layout_space_grid_vertical grid place-content-center`
              )}
            >
              {collections.map((collection, index) => (
                <CardCollectionList
                  key={index}
                  data={data}
                  collection={collection}
                  element={element}
                  preview={preview}
                />
              ))}
            </div>
          </>
        )}
      </div>
      <style jsx>
        {`
          .text-color-scheme {
            color: ${data.colorSchemeCollectionList?.text};
          }
          .button-link-scheme {
            color: ${data.colorSchemeCollectionList?.btnSolidlabel};
          }
          .background-color {
            background-color: ${data.colorSchemeCollectionList?.background};
          }
        `}
      </style>
    </section>
  );
}
